import { set } from 'lodash'

import { APP_LOADING, SET_SAVE_STATUS } from 'vx/mutations'
import AppConstants from '@/support/app-constants'

// state.
const state = {
  loading: true,
  show_save_status: false,
  save_status: AppConstants.save_status.SAVED
}

// usertstory settings state getters.
const getters = {}

// usertstory settings actions.
const actions = {}

// liabilities state mutations.
const mutations = {

  /**
   * Set a property on the view_options state.
   *
   * @return void
   */
  [APP_LOADING] (state, loading) {
    state.loading = loading
  },

  [SET_SAVE_STATUS] (state, status) {
    state.save_status = status
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
